import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Slider from 'react-slick';

import styles from './index.module.scss';
import commonStyles from '../index.module.scss';
import classnames from 'classnames';

import { stories, highlightElements } from 'resources/page/company/brand-stories/';
import autoBind from 'react-autobind';
import ExternalLink from 'ui/common/external-link';

export class BrandStory extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      highlightedIndex: null,
    };
  }

  handleHover(event, id) {
    this.setState({ highlightedIndex: id });
  }

  renderStory(story, index) {
    const { intl: { formatMessage } } = this.props;

    return (
      <div
        key={index}
        className={classnames(
          styles.slideBackgroundContainer,
          commonStyles.secPt1,
          commonStyles.secPtM2,
          commonStyles.secPb1,
          commonStyles.secPbM2,
          'flex-column flex-md-row'
        )}
      >
        <div className="flex-column flex-lg-row col-md-12 px-0 px-md-3 page-max-width">
          <div
            className={classnames(
              styles.slickMobileCustomInner,
              'col-12 col-lg-5 mr-auto flex-column d-flex'
            )}
          >
            <div className="pb-3 flex-column d-flex">
              <h2 className="typography-section-headline-big">
                {formatMessage(story.messages.title)}
              </h2>
              <h2 className="typography-section-headline-big">
                {formatMessage(story.messages.subtitle)}
              </h2>
            </div>
            <div className="pb-3">
              <p className={commonStyles.typographyPLarge}>
                <FormattedMessage
                  {...story.messages.description}
                  values={{
                    e_1: (
                      <span
                        className={
                          this.state.highlightedIndex === 'square' ? styles.textHighlight : ''
                        }
                      >
                        {formatMessage(highlightElements[0].messages.title)}
                      </span>
                    ),
                    e_2: (
                      <span
                        className={
                          this.state.highlightedIndex === 'circle' ? styles.textHighlight : ''
                        }
                      >
                        {formatMessage(highlightElements[1].messages.title)}
                      </span>
                    ),
                    e_3: (
                      <span
                        className={
                          this.state.highlightedIndex === 'triangle' ? styles.textHighlight : ''
                        }
                      >
                        {formatMessage(highlightElements[2].messages.title)}
                      </span>
                    ),
                    e_4: (
                      <span
                        className={
                          this.state.highlightedIndex === 'line' ? styles.textHighlight : ''
                        }
                      >
                        {formatMessage(highlightElements[3].messages.title)}
                      </span>
                    ),
                  }}
                />
              </p>
              <p className={classnames(commonStyles.typographyPLarge, 'pt-3')}>
                <FormattedMessage
                  id="pages.homeV3.brand-story.discover"
                  defaultMessage="Discover the Indorse brand design {here}."
                  values={{
                    here: (
                      <ExternalLink href="https://indorse.design">
                        <FormattedMessage
                          id="pages.homeV3.brand-story.discover.here"
                          defaultMessage="here"
                        />
                      </ExternalLink>
                    ),
                  }}
                />
              </p>
            </div>
          </div>
          <div
            className={classnames(
              styles.brandStoryImg,
              commonStyles.secPtM2,
              'offset-md-3 col-md-6 col-lg-5 offset-lg-0'
            )}
          >
            {story.img === 'isSvg' ? (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g className="story-element" onMouseOver={e => this.handleHover(e, 'square')}>
                  <path d="M125 250h125v125H125z" />
                </g>
                <g className="story-element" onMouseOver={e => this.handleHover(e, 'circle')}>
                  <circle cx="437.5" cy="437.5" r="62.5" />
                </g>
                <g className="story-element" onMouseOver={e => this.handleHover(e, 'triangle')}>
                  <path d="M374.97 125L250 250l125-.09z" />
                </g>
                <g className="story-element" onMouseOver={e => this.handleHover(e, 'line')}>
                  <path d="M377.21 374.96L375 375v-3.36L497.23 250l2.77.03v2.74zM375 125.41L250 3.1V0h2.33l118.78 116.21V0H375z" />
                  <path d="M500 250L375 127.69l-.06-2.66 2.81-.03 118.36 115.8V124.59H500zM127.69 250H125v-2.75l115.8-118.36H125V125h125zM250 125c-69.004-.077-124.923-55.996-125-125h3.93c.077 66.832 54.238 120.988 121.07 121.06V125zM3.94 250H0c.077-69.004 55.996-124.923 125-125v3.94C58.172 129.017 4.017 183.172 3.94 250zM3.94 375H0c.077-69.004 55.996-124.923 125-125v3.94C58.172 254.017 4.017 308.172 3.94 375zM250 253.94V250c69.004.077 124.923 55.996 125 125h-3.94c-.077-66.828-54.232-120.983-121.06-121.06zM125 496.06V500C55.996 499.923.077 444.004 0 375h3.94C4.017 441.828 58.172 495.983 125 496.06zM246.06 375H250c-.077 69.004-55.996 124.923-125 125v-3.94c66.828-.077 120.983-54.232 121.06-121.06zM251.94 500H250V375h3.88v121.05C318.71 495 371.12 441.1 371.12 375H375c0 68.93-55.21 125-123.06 125z" />
                </g>
              </svg>
            ) : (
              <img src={story.img} alt={story.name} className={styles.brandStoryImg} />
            )}
          </div>
        </div>
      </div>
    );
  }

  renderStorySlider() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
    };

    return (
      <div
        className={classnames(
          styles.companyBrandStorySliderDots,
          styles.companyBrandStorySlider,
          'container-fluid px-0'
        )}
      >
        <Slider className={classnames(styles.slickMobileCustomOuter)} {...settings}>
          {stories.map((story, index) => this.renderStory(story, index))}
        </Slider>
      </div>
    );
  }

  render() {
    return <div className={classnames(styles.storySlider)}>{this.renderStorySlider()}</div>;
  }
}

export default injectIntl(BrandStory);



// WEBPACK FOOTER //
// ./src/ui/pages/company/brand-story/index.js